var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.isEditorActive)?_c('div',{staticClass:"editor"},[_c('CloseButton',{on:{"close":_vm.closeEditor}}),_c(_vm.editorComponent,{tag:"component"})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }